import axios from "@/store/vue-axios";
import {Model} from "@/store/models/model";
export class GetPermissions extends Model {

  static entity = 'account_get_permissions'
  static primaryKey = 'key'
  // static apiEntity = 'permissions'

  static fields() {
    return {
        key: this.attr(null),
        title: this.attr(null),
        descr: this.attr(null),
        category: this.attr(null),
        type: this.attr(null)
      }
    }
    static async fetchPermissions(){
      const res = axios.get('/account/permissions')
        .then(response => {
          GetPermissions.insertOrUpdate({data:response.data['permissions']})
          console.log('GET PERMISSIONS MODEL',response.data)
        })
        .catch(error=>error)
      return GetPermissions.all()
    }
  static categories(){
    if(GetPermissions.all().length === 0){GetPermissions.fetchPermissions()}
    const categories = []
    GetPermissions.all().map(el=>{
      categories.includes(el.category) ? undefined : categories.push(el.category)
    })
    return categories
  }
  }
export default GetPermissions



// WEBPACK FOOTER //
// ./src/store/models/account/account_get_permissions.js